'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { PaginationContext } from './pagination.context.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
let i = {
    accessibleText: e$1.string
};
const Pagination = createComponent({
    displayName: 'Pagination',
    root: 'nav',
    propTypes: i,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.pagination,
    propConfig: {
        derivedProps () {
            let [e$1, r] = e.useState();
            return {
                labelId: e$1,
                setLabelId: r
            };
        },
        processProps (e) {
            var { accessibleText: t } = e;
            return _object_spread_props(_object_spread({
                'aria-label': null != t ? t : void 0
            }, _object_without_properties(e, [
                "accessibleText"
            ])), {
                role: 'navigation'
            });
        },
        classNames: [
            'swan-pagination'
        ],
        wrapRoot: (e$1, r, o)=>e.createElement(PaginationContext.Provider, {
                value: {
                    labelId: r.labelId,
                    setLabelId: r.setLabelId
                }
            }, o)
    }
});

export { Pagination };
